import { config, DEFAULT_CONFIG } from '@qapline/config';

import { EAuthRole } from '../types';

export const passwordMinLength = 8;
const { commissions, offers, dispatcher, auth } = DEFAULT_CONFIG.routes;
export const defaultRedirects: Partial<Record<EAuthRole, string>> = {
    [EAuthRole.QaplineEmployee]: commissions.list,
    [EAuthRole.Dispatcher]: offers.list,
    [EAuthRole.OnboardingUser]: dispatcher.onboarding,
    [EAuthRole.AttachmentsUploader]: auth.login,
};
